import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)<{ $iconAlign?: 'center' | 'flex-start' }>`
    && {
        border-radius: 6px;
        align-items: ${({ $iconAlign }) => $iconAlign ?? 'center'};

        ${({ $iconAlign }) =>
            $iconAlign === 'flex-start' &&
            `
            .ant-alert-icon {
                margin-top: 6px;
            }
        `}

        &.ant-alert-warning {
            background: var(--orange-1);
            border-color: var(--orange-3);
            .ant-alert-icon {
                color: var(--orange-6);
            }
        }
        &.ant-alert-error {
            background: var(--dust-red-1);
            border-color: var(--dust-red-4);
            .ant-alert-icon {
                color: var(--dust-red-6);
            }
        }
        &.ant-alert-info {
            background: var(--blue-1);
            border-color: var(--blue-3);
            .ant-alert-icon {
                color: var(--blue-6);
            }
        }
        &.ant-alert-success {
            background: var(--polar-green-1);
            border-color: var(--polar-green-5);
            .ant-alert-icon {
                color: var(--polar-green-6);
            }
        }
    }
`;
